module.exports = __webpack_public_path__ + "static/media/TXT.b575bb74.svg";